import React, { useEffect, useState } from 'react';
import Table from '../../shared/components/layout/Table';
import { transformData } from '../../super-admin/utils/transformData';
import Cookies from 'js-cookie';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import {
  handleCheckAccomodationDelete,
  deleteAccomodation,
  downloadAccomodationTemplate,
  uploadAccomodationTemplate
} from '../services/api/implementation/impl';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import Modal from '../../shared/components/ui/Modal';
import mixpanel from 'mixpanel-browser';
import Button from '../../shared/components/ui/Button';
import Loader from '../../shared/components/ui/Loader';
import { Plus, ChevronDown, Download, Upload } from 'lucide-react';
import editIcon from '../../shared/assets/svg/edit.svg';
import deleteIcon from '../../shared/assets/svg/delete.svg';
import { createPortal } from 'react-dom';
import { useParams } from 'react-router-dom';

const AccommodationDetails = ({ accommodations, onEdit, refresh, handleToggleCreateNewModal }) => {
  const userId = Cookies.get('userId');
  const [selectedType, setSelectedType] = useState('ALL');
  const [tableHeight, setTableHeight] = useState('auto');
  const [canDelete, setCanDelete] = useState(null);
  const { id: projectId } = useParams();
  const rawMeasurementUnit = Cookies.get('measurement_type');
  const [resData, setResData] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const accommodationHeaderRef = React.useRef(null);
  const [accommodationDropdownRect, setAccommodationDropdownRect] = useState(null);
  const [isUploadTemplateModalOpen, setIsUploadTemplateModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploadErrorModalOpen, setIsUploadErrorModalOpen] = useState(false);
  const [uploadErrors, setUploadErrors] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [hoverTimeout, setHoverTimeout] = useState(null);
  const [plotAreaUnit, setPlotAreaUnit] = useState(
    rawMeasurementUnit === 'sq/ft' || rawMeasurementUnit === 'sq/mt' ? rawMeasurementUnit : 'sq/ft'
  );

  const measurementUnit =
    !rawMeasurementUnit || rawMeasurementUnit === 'null' || rawMeasurementUnit === 'undefined'
      ? 'sq/ft'
      : rawMeasurementUnit;

  const accommodationTypes = {
    ALL: {
      title: 'All',
      headers: [
        'Name',
        {
          label: 'Type',
          dropdown: true,
          dropdownOptions: [
            { id: 'ALL', value: 'ALL', label: 'All' },
            { id: 'INDEPENDENT', value: 'INDEPENDENT', label: 'Independent' },
            { id: 'GROUP', value: 'GROUP', label: 'Group' },
            { id: 'PARKING', value: 'PARKING', label: 'Parking' }
          ],
          onDropdownSelect: (id) => {
            if (id) {
              handleTypeChange(id);
            }
          }
        },
        'Unit Type',
        `Plot Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        `Build Up Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        `Carpet Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        'Actions'
      ],
      form: [
        'id',
        'name',
        'accomodationType',
        'unitType',
        'plotArea',
        'buildUpArea',
        'carpetArea',
        'actions'
      ]
    },
    INDEPENDENT: {
      title: 'Independent',
      headers: [
        'Name',
        {
          label: 'Type',
          dropdown: true,
          dropdownOptions: [
            { id: 'ALL', value: 'ALL', label: 'All' },
            { id: 'INDEPENDENT', value: 'INDEPENDENT', label: 'Independent' },
            { id: 'GROUP', value: 'GROUP', label: 'Group' },
            { id: 'PARKING', value: 'PARKING', label: 'Parking' }
          ],
          onDropdownSelect: (id) => {
            if (id) {
              handleTypeChange(id);
            }
          }
        },
        'Unit Type',
        `Plot Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        `Build Up Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        `Carpet Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        'Actions'
      ],
      form: [
        'id',
        'name',
        'accomodationType',
        'unitType',
        'plotArea',
        'buildUpArea',
        'carpetArea',
        'actions'
      ]
    },
    GROUP: {
      title: 'Group',
      headers: [
        'Name',
        {
          label: 'Type',
          dropdown: true,
          dropdownOptions: [
            { id: 'ALL', value: 'ALL', label: 'All' },
            { id: 'INDEPENDENT', value: 'INDEPENDENT', label: 'Independent' },
            { id: 'GROUP', value: 'GROUP', label: 'Group' },
            { id: 'PARKING', value: 'PARKING', label: 'Parking' }
          ],
          onDropdownSelect: (id) => {
            if (id) {
              handleTypeChange(id);
            }
          }
        },
        'Unit Type',
        `Build Up Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        `Carpet Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        'Actions'
      ],
      form: ['id', 'name', 'accomodationType', 'unitType', 'buildUpArea', 'carpetArea', 'actions']
    },
    PARKING: {
      title: 'Parking',
      headers: [
        'Name',
        {
          label: 'Type',
          dropdown: true,
          dropdownOptions: [
            { id: 'ALL', value: 'ALL', label: 'All' },
            { id: 'INDEPENDENT', value: 'INDEPENDENT', label: 'Independent' },
            { id: 'GROUP', value: 'GROUP', label: 'Group' },
            { id: 'PARKING', value: 'PARKING', label: 'Parking' }
          ],
          onDropdownSelect: (id) => {
            if (id) {
              handleTypeChange(id);
            }
          }
        },
        'Unit Type',
        `Build Up Area (${measurementUnit ? measurementUnit : 'sq/ft'})`,
        'Electrified',
        'Actions'
      ],
      form: ['id', 'name', 'accomodationType', 'unitType', 'buildUpArea', 'electrified', 'actions']
    }
  };

  const getData = (type) => {
    // If type is 'ALL', don't filter - show all accommodations
    const filteredAccommodations =
      type === 'ALL'
        ? accommodations
        : accommodations?.filter((item) => item.accomodationType === type);

    return filteredAccommodations?.map((item) => {
      // Format numeric values preserving decimal places
      const formattedItem = {
        ...item,
        plotArea: item.plotArea?.toString() || '',
        buildUpArea: item.buildUpArea?.toString() || '',
        carpetArea: item.carpetArea?.toString() || ''
      };
      return transformData(formattedItem, accommodationTypes[type].form);
    });
  };

  const calculateHeight = (data) => {
    // Let table grow naturally based on content
    if (data?.length == 0) {
      return '200px'; // Minimum height for empty state
    }
    return 'auto'; // Let it grow naturally
  };

  // 1. Accommodation List Viewed (on mount and when type changes)

  // Track page view
  useEffect(() => {
    mixpanel.track('Accommodation Details Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    const data = getData(selectedType);
    setTableHeight(calculateHeight(data));
    mixpanel.track('Accommodation List Viewed', { type: selectedType, count: data?.length || 0 });
  }, [selectedType, accommodations]);

  const handleTypeChange = (e) => {
    setSelectedType(e);

    mixpanel.track('Accommodation Type Changed', {
      user_id: userId,
      from_type: selectedType,
      to_type: e,
      timestamp: new Date().toISOString()
    });
  };

  // Conversion function for plot area
  const convertPlotArea = (value, fromUnit, toUnit) => {
    if (!value || value === '---') return value;

    const numValue = parseFloat(value);
    if (isNaN(numValue)) return value;

    // Normalize unit formats (handle variations like sqft, sq/ft, sq ft, etc.)
    const normalizeUnit = (unit) => {
      if (!unit) return 'sq/ft';
      const normalized = unit.toLowerCase().replace(/\s+/g, '');
      if (normalized === 'sqft' || normalized === 'sq/ft' || normalized === 'sqfeet')
        return 'sq/ft';
      if (normalized === 'sqmt' || normalized === 'sq/mt' || normalized === 'sqm') return 'sq/mt';
      if (normalized === 'guntha' || normalized === 'gunta') return 'guntha';
      if (normalized === 'cents' || normalized === 'cent') return 'cents';
      return unit;
    };

    const normalizedFromUnit = normalizeUnit(fromUnit);
    const normalizedToUnit = normalizeUnit(toUnit);

    // If same unit, return as is
    if (normalizedFromUnit === normalizedToUnit) return numValue.toFixed(2);

    // Conversion factors (how many sq/ft in 1 unit)
    const sqFtPerUnit = {
      'sq/ft': 1,
      'sq/mt': 10.764, // 1 sq/mt = 10.764 sq/ft
      guntha: 1089, // 1 guntha = 1089 sq/ft
      cents: 435.6 // 1 cent = 435.6 sq/ft
    };

    // Convert: value in fromUnit → sq/ft → toUnit
    const valueInSqFt = numValue * sqFtPerUnit[normalizedFromUnit];
    const convertedValue = valueInSqFt / sqFtPerUnit[normalizedToUnit];

    return convertedValue.toFixed(2);
  };

  // Handle plot area unit selection
  const handlePlotAreaUnitChange = (unit) => {
    setPlotAreaUnit(unit);

    mixpanel.track('Plot Area Unit Changed', {
      user_id: userId,
      from_unit: plotAreaUnit,
      to_unit: unit,
      timestamp: new Date().toISOString()
    });
  };

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => handleCheckAccomodationDelete(id),
    onMutate: (id) => {
      setIsSubmitting(true); // Disable the button when mutation starts
      mixpanel.track('Check Accommodation Delete Started', {
        user_id: userId,
        accommodation_id: id,
        type: selectedType,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: async (result, id) => {
      setIsSubmitting(false);

      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        console.error('Error checking dependencies', result);
        toast.error(
          result?.response?.data?.message || result?.message || 'Error checking dependencies'
        );

        mixpanel.track('Check Accommodation Delete Failed', {
          user_id: userId,
          accommodation_id: id,
          type: selectedType,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        return;
      }

      const accommodationItem = getData(selectedType)?.find(
        (item) => parseInt(item.id) === parseInt(id)
      );
      const AccommodationsName = accommodationItem?.name || 'accommodation';

      if (result.canDelete) {
        setCanDelete('yes');
        setResData({ name: AccommodationsName });
        setSelectedIds([parseInt(id)]);

        mixpanel.track('Accommodation Delete Allowed', {
          user_id: userId,
          accommodation_id: id,
          accommodation_name: AccommodationsName,
          type: selectedType,
          timestamp: new Date().toISOString()
        });
      } else {
        setResData({ ...result, name: AccommodationsName });
        setCanDelete('no');

        mixpanel.track('Accommodation Delete Blocked', {
          user_id: userId,
          accommodation_id: id,
          accommodation_name: AccommodationsName,
          type: selectedType,
          reasons: result.reason,
          timestamp: new Date().toISOString()
        });
      }
    },
    onError: (err, id) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking dependencies');

      mixpanel.track('Check Accommodation Delete Failed', {
        user_id: userId,
        accommodation_id: id,
        type: selectedType,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteAccomodation(payload),
    onMutate: (variables) => {
      setIsSubmitting(true); // Disable the button when mutation starts
      mixpanel.track('Delete Accommodation Started', {
        user_id: userId,
        accommodation_ids: variables?.ids,
        type: selectedType,
        is_bulk: variables?.ids?.length > 1,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: (result, variables) => {
      setIsSubmitting(false);

      // Check if result is an error object (API now returns errors instead of throwing)
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        console.error('Error deleting accommodation', result);
        toast.error(
          result?.response?.data?.message || result?.message || 'Error deleting accommodation'
        );

        mixpanel.track('Delete Accommodation Failed', {
          user_id: userId,
          accommodation_ids: variables?.ids,
          type: selectedType,
          is_bulk: variables?.ids?.length > 1,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        return;
      }

      toast.success('Accommodations Deleted Successfully');
      refresh?.();

      mixpanel.track('Delete Accommodation Success', {
        user_id: userId,
        accommodation_ids: variables?.ids,
        type: selectedType,
        is_bulk: variables?.ids?.length > 1,
        timestamp: new Date().toISOString()
      });
    },
    onError: (err, variables) => {
      setIsSubmitting(false);
      console.error('Error deleting accommodation', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting accommodation');

      mixpanel.track('Delete Accommodation Failed', {
        user_id: userId,
        accommodation_ids: variables?.ids,
        type: selectedType,
        is_bulk: variables?.ids?.length > 1,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    handleDeleteFn(payload);
  };

  // Accommodation Edit Clicked
  const handleEdit = (id) => {
    mixpanel.track('Accommodation Edit Clicked', {
      user_id: userId,
      accommodation_id: id,
      type: selectedType,
      timestamp: new Date().toISOString()
    });
    onEdit(id);
  };

  // PortalDropdown component
  const PortalDropdown = ({ anchorRect, children, onClose }) => {
    if (!anchorRect) return null;
    const dropdownRef = React.useRef(null);

    React.useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          onClose && onClose();
        }
      };
      const handleEscape = (event) => {
        if (event.key === 'Escape') {
          onClose && onClose();
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('keydown', handleEscape);
      };
    }, [onClose]);
    return createPortal(
      <div
        ref={dropdownRef}
        className="absolute bg-white border rounded shadow z-[1000]"
        style={{
          position: 'fixed',
          left: anchorRect.left,
          top: anchorRect.bottom,
          minWidth: anchorRect.width,
          maxHeight: '250px',
          overflowY: 'auto'
        }}
        onClick={(e) => e.stopPropagation()}>
        {children}
      </div>,
      document.body
    );
  };

  // Handler to open dropdown and set position
  const handleHeaderDropdownClick = (type, event) => {
    // If clicking the same dropdown that's already open, close it
    if (openDropdown === type) {
      setOpenDropdown(null);
      return;
    }

    if (type === 'accommodation' && accommodationHeaderRef?.current) {
      setAccommodationDropdownRect(accommodationHeaderRef?.current?.getBoundingClientRect());
    }
    setOpenDropdown(type);
  };

  // Handler to close dropdown
  const handleCloseDropdown = () => setOpenDropdown(null);

  // Handler to select type
  const handleSelectDropdownItem = (type) => {
    setOpenDropdown(null);
    handleTypeChange(type);
  };

  // Download template mutation
  const { mutate: handleDownloadAccommodationTemplate } = useMutation({
    mutationFn: () => downloadAccomodationTemplate(projectId),
    onMutate: () => {
      setIsSubmitting(true);
      mixpanel.track('Download Accommodation Template Started', {
        user_id: userId,
        type: selectedType,
        timestamp: new Date().toISOString()
      });
    },
    onSuccess: (data) => {
      setIsSubmitting(false);
      if (!data || data.size === 0) {
        toast.error('Error: File data is empty or invalid.');
        return;
      }

      const url = window.URL.createObjectURL(new Blob([data]));
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `Accommodation_Template.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      toast.success('Accommodation Template Downloaded');

      mixpanel.track('Download Accommodation Template Success', {
        user_id: userId,
        type: selectedType,
        timestamp: new Date().toISOString()
      });
    },
    onError: (error) => {
      setIsSubmitting(false);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Error in downloading Accommodation Template'
      );
      mixpanel.track('Download Accommodation Template Failed', {
        user_id: userId,
        type: selectedType,
        error_message: error?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    }
  });

  // Handler for file selection in upload modal
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  // Handler for download template button
  const handleDownloadTemplateClick = () => {
    handleDownloadAccommodationTemplate();
  };

  // Handler for upload template button
  const handleUploadTemplateClick = () => {
    setIsUploadTemplateModalOpen(true);
  };

  // Handler for upload template submission
  const handleUploadTemplateSubmit = async () => {
    if (!selectedFile) {
      toast.error('Please select a file');
      return;
    }

    try {
      setIsSubmitting(true);
      const formData = new FormData();
      formData.append('file', selectedFile);

      formData.append('project_id', projectId);

      const response = await uploadAccomodationTemplate(formData);
      console.log('Uploaded template', response);

      // Check if there are errors in the response
      if (response?.data?.errors && response.data.errors.length > 0) {
        // Show error modal with validation errors
        setUploadErrors(response.data.errors);
        setIsUploadErrorModalOpen(true);
        setIsUploadTemplateModalOpen(false);
      } else {
        // No errors, proceed with success flow
        toast.success('Accommodation Template uploaded successfully');
        refresh?.();
        setIsUploadTemplateModalOpen(false);
        setSelectedFile(null);

        mixpanel.track('Upload Accommodation Template Success', {
          user_id: userId,
          type: selectedType,
          timestamp: new Date().toISOString()
        });
      }
    } catch (error) {
      console.error('Upload error:', error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Failed to upload Accommodation Template'
      );
      mixpanel.track('Upload Accommodation Template Failed', {
        user_id: userId,
        type: selectedType,
        error_message: error?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full flex flex-col px-5 bg-gray-100 overflow-hidden">
      <Loader isVisible={isSubmitting} />
      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this accommodation'}'`}
          onClose={() => {
            setCanDelete(null);
            mixpanel.track('Accommodation Delete Cancelled', { type: selectedType });
          }}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <p className="text-center">
              Looks like this accomodation has dependencies, please delete following units to
              proceed
            </p>
            <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
              {resData &&
                resData.reason?.map((r, index) => (
                  <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                    {index + 1}.{r}
                    {index < resData.reason.length - 1 ? ', ' : ''}
                  </span>
                ))}
            </div>
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
            mixpanel.track('Accommodation Delete Cancelled', { type: selectedType });
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'accommodation'}
            onClose={() => {
              setCanDelete(null);
              setSelectedIds([]);
              mixpanel.track('Accommodation Delete Cancelled', { type: selectedType });
            }}
            data={getData(selectedType)}
            type={'accommodation'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      {/* Upload Template Modal */}
      {isUploadTemplateModalOpen && (
        <Modal
          width={50}
          confirmOnClose={true}
          isDirty={true}
          name="Upload Accommodation Template"
          onClose={() => {
            setIsUploadTemplateModalOpen(false);
            setSelectedFile(null);
          }}>
          <div className="flex flex-col justify-between items-start gap-4">
            <div className="flex flex-col gap-4 w-full">
              <div className="w-full">
                <label className="text-gray-600 mb-2 block">Select File</label>
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={handleFileSelect}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {selectedFile && (
                  <p className="text-sm text-gray-600 mt-1">Selected: {selectedFile.name}</p>
                )}
              </div>

              <div className="flex justify-end items-center space-x-4 mt-4">
                <Button
                  type="button"
                  onClick={() => {
                    setIsUploadTemplateModalOpen(false);
                    setSelectedFile(null);
                  }}
                  displayType="secondary">
                  Cancel
                </Button>
                <Button
                  type="button"
                  onClick={handleUploadTemplateSubmit}
                  disabled={!selectedFile || isSubmitting}>
                  {isSubmitting ? 'Uploading...' : 'Upload Template'}
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {/* Upload Error Modal */}
      {isUploadErrorModalOpen && (
        <Modal
          width={50}
          confirmOnClose={true}
          isDirty={true}
          name="Upload Validation Errors"
          onClose={() => {
            setIsUploadErrorModalOpen(false);
            setUploadErrors([]);
          }}>
          <div className="flex flex-col justify-between items-start gap-4">
            <div className="flex flex-col gap-4 w-full">
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <p className="text-sm text-red-800 mb-3">
                  The following errors were found in your uploaded file. Please fix these issues and
                  try uploading again:
                </p>
                <ul className="space-y-2">
                  {uploadErrors.map((error, index) => (
                    <li key={index} className="text-sm text-red-700 flex items-start">
                      <span className="text-red-500 mr-2">•</span>
                      <span>{error}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex justify-end items-center space-x-4 mt-4">
                <Button
                  type="button"
                  onClick={() => {
                    setIsUploadErrorModalOpen(false);
                    setUploadErrors([]);
                  }}
                  displayType="secondary">
                  Close
                </Button>
                <Button
                  type="button"
                  onClick={() => {
                    setIsUploadErrorModalOpen(false);
                    setUploadErrors([]);
                    // Reopen upload modal for retry
                    setIsUploadTemplateModalOpen(true);
                  }}
                  className="bg-blue-600 hover:bg-blue-700 text-white">
                  Try Again
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      <div
        className="fixed bottom-8 right-8 z-50"
        onMouseEnter={() => {
          if (hoverTimeout) {
            clearTimeout(hoverTimeout);
            setHoverTimeout(null);
          }
          setIsExpanded(true);
        }}
        onMouseLeave={() => {
          const timeout = setTimeout(() => {
            setIsExpanded(false);
          }, 200); // 200ms delay before collapsing
          setHoverTimeout(timeout);
        }}>
        <div className="relative">
          {/* Expanded Options Container */}
          {isExpanded && (
            <div
              className="absolute bottom-16 right-0 flex flex-col gap-3 pointer-events-auto items-end"
              onMouseEnter={() => {
                if (hoverTimeout) {
                  clearTimeout(hoverTimeout);
                  setHoverTimeout(null);
                }
              }}
              onMouseLeave={() => {
                const timeout = setTimeout(() => {
                  setIsExpanded(false);
                }, 200);
                setHoverTimeout(timeout);
              }}>
              {/* Download Template Option */}
              <div className="flex items-center justify-center gap-3 whitespace-nowrap">
                <span className="text-sm font-medium text-white bg-black px-3 py-2 rounded flex items-center">
                  Download Template (Irregular)
                </span>
                <button
                  onClick={handleDownloadTemplateClick}
                  disabled={isSubmitting}
                  className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-500 hover:bg-blue-600 transition-colors duration-200 shadow-lg border-0">
                  <Download size={16} className="text-white" />
                </button>
              </div>

              {/* Upload Template Option */}
              <div className="flex items-center justify-center gap-3 whitespace-nowrap">
                <span className="text-sm font-medium text-white bg-black px-3 py-2 rounded flex items-center">
                  Upload Template (Irregular)
                </span>
                <button
                  onClick={handleUploadTemplateClick}
                  disabled={isSubmitting}
                  className="flex items-center justify-center w-10 h-10 rounded-full bg-green-500 hover:bg-green-600 transition-colors duration-200 shadow-lg border-0">
                  <Upload size={16} className="text-white" />
                </button>
              </div>
            </div>
          )}

          {/* Main Button */}
          <Button
            displayType="primary"
            onClick={() => {
              mixpanel.track('Create New Accommodation Button Clicked', {
                user_id: userId,
                type: selectedType,
                timestamp: new Date().toISOString()
              });
              handleToggleCreateNewModal();
            }}
            customStyle={{
              borderRadius: '50%',
              width: '56px',
              height: '56px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
              transition: 'all 0.3s ease',
              position: 'relative',
              zIndex: 10
            }}>
            <Plus size={24} color="white" />
          </Button>
        </div>
      </div>

      <div className="mt-7">
        {/* Unit Selector Above Table */}
        <div className="mb-4 flex items-center gap-3">
          <span className="text-sm font-medium text-gray-700">Area Unit:</span>
          <select
            value={plotAreaUnit}
            onChange={(e) => handlePlotAreaUnitChange(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none bg-white text-gray-900 cursor-pointer">
            <option value="sq/ft">sq/ft</option>
            <option value="sq/mt">sq/mt</option>
            <option value="guntha">guntha</option>
            <option value="cents">cents</option>
          </select>
        </div>

        <div className="accommodation-table-container h-[calc(100vh-14rem)]  overflow-auto">
          <style>{`
            .accommodation-table-container .table-body {
              position: static !important;
              overflow-y: visible !important;
              max-height: none !important;
              height: auto !important;
              top: auto !important;
              padding-bottom: 0 !important;
            }
            .accommodation-table-container .table-container {
              height: auto !important;
            }
            .accommodation-table-container > div {
              height: auto !important;
            }
          `}</style>
          <div className="overflow-scroll hide-scrollbar w-full relative rounded-t-lg">
            <table className="text-left w-full">
              <thead className="bg-gray-200 !text-gray-600 w-full sticky top-0 z-20">
                <tr className="font-normal h-[3rem] w-full">
                  <th className="px-4 py-2 border-b font-normal">Name</th>
                  <th
                    className="px-4 py-2 border-b font-normal relative"
                    ref={accommodationHeaderRef}>
                    <span>Type</span>
                    <button
                      className="ml-1 align-middle"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleHeaderDropdownClick('accommodation', e);
                      }}>
                      <ChevronDown size={16} />
                    </button>
                    {openDropdown === 'accommodation' && accommodationDropdownRect && (
                      <PortalDropdown
                        anchorRect={accommodationDropdownRect}
                        onClose={handleCloseDropdown}>
                        {[
                          { id: 'ALL', label: 'All' },
                          { id: 'INDEPENDENT', label: 'Independent' },
                          { id: 'GROUP', label: 'Group' },
                          { id: 'PARKING', label: 'Parking' }
                        ].map((type) => (
                          <div
                            key={type.id}
                            className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                              type.id === selectedType && 'bg-blue-100'
                            }`}
                            onClick={() => handleSelectDropdownItem(type.id)}>
                            {type.label}
                          </div>
                        ))}
                      </PortalDropdown>
                    )}
                  </th>
                  <th className="px-4 py-2 border-b font-normal">Unit Type</th>
                  {selectedType === 'INDEPENDENT' && (
                    <th className="px-4 py-2 border-b font-normal">Plot Area ({plotAreaUnit})</th>
                  )}
                  <th className="px-4 py-2 border-b font-normal">Build Up Area ({plotAreaUnit})</th>
                  <th className="px-4 py-2 border-b font-normal">Carpet Area ({plotAreaUnit})</th>
                  {selectedType === 'PARKING' && (
                    <th className="px-4 py-2 border-b font-normal">Electrified</th>
                  )}
                  <th className="px-4 py-2 border-b font-normal">Actions</th>
                </tr>
              </thead>
              <tbody>
                {getData(selectedType) && getData(selectedType)?.length > 0 ? (
                  getData(selectedType)?.map((item, index) => (
                    <tr
                      key={item?.id || index}
                      className="border-b hover:bg-gray-50 bg-white h-[3.5rem]">
                      <td className="px-4 py-2">{item?.name || '---'}</td>
                      <td className="px-4 py-2">{item?.accomodationType || '---'}</td>
                      <td className="px-4 py-2">{item?.unitType || '---'}</td>
                      {selectedType === 'INDEPENDENT' && (
                        <td className="px-4 py-2">
                          {item?.plotArea
                            ? convertPlotArea(
                                item.plotArea,
                                measurementUnit || 'sq/ft',
                                plotAreaUnit
                              )
                            : '---'}
                        </td>
                      )}
                      <td className="px-4 py-2">
                        {item?.buildUpArea
                          ? convertPlotArea(
                              item.buildUpArea,
                              measurementUnit || 'sq/ft',
                              plotAreaUnit
                            )
                          : '---'}
                      </td>
                      <td className="px-4 py-2">
                        {item?.carpetArea
                          ? convertPlotArea(
                              item.carpetArea,
                              measurementUnit || 'sq/ft',
                              plotAreaUnit
                            )
                          : '---'}
                      </td>
                      {selectedType === 'PARKING' && (
                        <td className="px-4 py-2">{item?.electrified || '---'}</td>
                      )}
                      <td className="px-4 py-2">
                        <div className="flex items-center justify-center w-full relative gap-2">
                          <div
                            className="cursor-pointer hover:scale-110 transition-all duration-300 action-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(item?.id);
                            }}>
                            <img src={editIcon} alt="edit__icon" />
                          </div>
                          <div
                            className="cursor-pointer hover:scale-110 transition-all duration-300 action-button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCheckDelete(item?.id);
                            }}>
                            <img src={deleteIcon} alt="delete__icon" />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={
                        selectedType === 'INDEPENDENT' ? 7 : selectedType === 'PARKING' ? 7 : 6
                      }
                      className="text-center py-10 align-middle">
                      <div className="flex flex-col items-center justify-center w-full h-full">
                        <h2 className="text-lg font-bold text-gray-800 mb-1">No Data Found</h2>
                        <p className="text-gray-600 text-sm">
                          No accommodations found for {selectedType.toLowerCase()} type.
                          <br />
                          Proceed with adding new accommodation.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccommodationDetails;
